import { useState } from "react"
import { Drawer } from "./drawer";
import { TableFilterComponent } from "./table-filter-style";

export const FilterDrawerComponent = ({ columnData, rowData, filterTypeLists, searchCriteriaList, setFilteredData, showFilter, setShowFilter, initiateSearch }: any) => {

    return (
        <>

            {
                showFilter && <div className="z-9999">
                    <Drawer isOpen={showFilter} onClose={() => setShowFilter(false)}>
                        <div className="flex flex-row w-full h-10 justify-end p-2">
                            <button onClick={() => setShowFilter(false)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    color="#000000"
                                    fill="none"
                                >
                                    <path
                                        d="M14.9994 15L9 9M9.00064 15L15 9"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                    />
                                </svg>
                            </button>
                        </div>

                        <div className="flex flex-col w-full h-full overflow-auto bg-white">
                            <TableFilterComponent columnData={columnData} rowData={rowData} filterTypeLists={filterTypeLists} searchCriteriaList={searchCriteriaList} setFilteredData={setFilteredData} initiateSearch={initiateSearch} />
                        </div>
                    </Drawer>
                </div>
            }

        </>
    )
}